module.exports = __webpack_public_path__ + "img/car-out.9da0e08a.png";